<template>
  <div>
    <v-tooltip
      left>
      <template
        v-slot:activator="{ on }">
        <v-btn
          fab
          x-small
          depressed
          color="error"
          v-on="on"
          @click="isOpen = true">
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('combos.modals.remove.tooltip') }}</span>
    </v-tooltip>

    <v-dialog @keydown.esc="isOpen=false" v-model="isOpen" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">Eliminar {{ combo.name }}</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            small
            rounded
            color="primary"
            @click="closeDialog">
            {{ $t('messages.no') }}
          </v-btn>
          <v-btn
            small
            rounded
            depressed
            color="primary"
            @click="remove">
            {{ $t('messages.yes') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Combo from '@/models/Combo'

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    let combo = new Combo(this.item.$)

    return {
      isOpen: false,
      overlay: false,
      combo
    }
  },
  methods: {
    remove: async function () {
      this.overlay = true
      try {
        await this.combo.delete()
        this.$emit('deleted')
        this.closeDialog()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    closeDialog: function () {
      this.isOpen = false
      this.$emit('close', false)
    }
  }
}
</script>
